// ============================================================================
// CANCUN100 — BarraMovil.js  (APP 2/24: barra inferior fija del agente en móvil, < 900 px)
// ----------------------------------------------------------------------------
// Cinco entradas con ícono Lucide y etiqueta: Nueva reserva · Mis ventas · Mi bolsa · Horarios · Más.
// «Más» abre una hoja desde abajo con el resto del menú (Lista de precios, Mi panel…) y Salir.
// Respeta env(safe-area-inset-bottom). Solo agentes: el admin sigue con ☰ (HojaMenuMovil / menú lateral).
// ============================================================================
import React, { useState } from 'react';
import { Ic } from './iconos';

const PRINCIPALES = [
  ['nueva-reserva', 'Nueva', 'FilePlus2'],
  ['mis-ventas', 'Ventas', 'TrendingUp'],
  ['mi-bolsa', 'Mi bolsa', 'Wallet'],
  ['horarios', 'Horarios', 'CalendarDays'],
];
const ICONO_RESTO = { 'lista-precios': 'Tag', 'mi-panel': 'UserRound' };

export default function BarraMovil({ activo, items = [], onSelect, onSalir, tema, onCambiarTema }) {
  const [mas, setMas] = useState(false);
  const resto = items.filter(([k]) => !PRINCIPALES.some(([p]) => p === k));
  const masActivo = resto.some(([k]) => k === activo);
  const elegir = (k) => { setMas(false); onSelect(k); };
  const limpia = (l) => String(l || '').replace(/^[^\p{L}\p{N}]+/u, '').trim();
  return (
    <>
      <nav className="c100-barra" aria-label="Navegación">
        {PRINCIPALES.map(([k, l, ic]) => (
          <button key={k} type="button" aria-current={activo === k ? 'page' : undefined} onClick={() => elegir(k)}><Ic n={ic} size={22} /><span>{l}</span></button>
        ))}
        <button type="button" aria-current={masActivo ? 'page' : undefined} aria-haspopup="dialog" aria-expanded={mas} onClick={() => setMas(true)}><Ic n="Menu" size={22} /><span>Más</span></button>
      </nav>
      {mas && (
        <div className="c100-hoja" role="dialog" aria-modal="true" aria-label="Más" onClick={() => setMas(false)}>
          <div className="c100-hoja__panel" onClick={(e) => e.stopPropagation()}>
            <div className="c100-hoja__asa" aria-hidden="true" />
            {resto.map(([k, l]) => (
              <button key={k} type="button" className="c100-hoja__item" aria-current={activo === k ? 'page' : undefined} onClick={() => elegir(k)}><Ic n={ICONO_RESTO[k] || 'ClipboardList'} /><span>{limpia(l)}</span></button>
            ))}
            {onCambiarTema && <button type="button" className="c100-hoja__item" onClick={onCambiarTema}><Ic n={tema === 'light' ? 'Moon' : 'Sun'} /><span>{tema === 'light' ? 'Modo oscuro' : 'Modo claro'}</span></button>}
            <button type="button" className="c100-hoja__item c100-hoja__item--salir" onClick={() => { setMas(false); if (onSalir) onSalir(); }}><Ic n="LogOut" /><span>Salir</span></button>
          </div>
        </div>
      )}
    </>
  );
}
